import {db} from "../../../db";
import {LotoCardboard} from "../../domain/entities/LotoCardboard";
import {liveQuery} from "dexie";
import {NewLotoCardboardPayload, LotoCardboardRepository} from "../../application/ports/LotoCardboardRepository";
import {randomId} from "../../../util/ids";

export class IndexedDbLotoCardboardRepository implements LotoCardboardRepository {
    async list(): Promise<LotoCardboard[]> {
        return db.lotoCardboards.toArray();
    }

    async add(lotoCardboard: NewLotoCardboardPayload): Promise<LotoCardboard> {
        const payload: LotoCardboard = {
            id: lotoCardboard.id ?? randomId(),
            label: lotoCardboard.label,
            numbers: lotoCardboard.numbers,
            rows: lotoCardboard.rows,
            barcode: lotoCardboard.barcode,
            createdAt: lotoCardboard.createdAt ?? new Date().toISOString(),
        };
        await db.lotoCardboards.put(payload);
        return payload;
    }

    async update(id: string, partial: Partial<LotoCardboard>): Promise<void> {
        await db.lotoCardboards.update(id, partial);
    }

    async delete(id: string): Promise<void> {
        await db.lotoCardboards.delete(id);
    }

    async deleteAll(): Promise<void> {
        await db.lotoCardboards.clear();
    }

    watchAll(onChange: (lotoCardboards: LotoCardboard[]) => void): () => void {
        const subscription = liveQuery(() => db.lotoCardboards.toArray()).subscribe({
            next: (nextLotoCardboards) => onChange(nextLotoCardboards),
            error: () => {
                // ignore errors for now
            },
        });
        return () => subscription.unsubscribe();
    }
}
